export default {
  path: '/imageFactory',
  name: 'imageFactory',
  meta: { title: '图片梦工厂' },
  children: [
    {
      path: '/imageFactory/:type',
      name: 'imageFactoryIndex',
      component: () => import('@/views/imageFactory/index.vue'),
      meta: { title: '图片梦工厂', subTitle: 'AI 极速生成，搞定营销视觉素材', key: 'imageFactory' },
    },
  ],
};
